import React from "react";

export default function CloseIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none">
      <path
        fill="#3E4957"
        d="M3.22 4.28a.75.75 0 0 1 1.06-1.06L12 10.94l7.72-7.72a.75.75 0 1 1 1.06 1.06L13.06 12l7.72 7.72a.75.75 0 1 1-1.06 1.06L12 13.06l-7.72 7.72a.75.75 0 0 1-1.06-1.06L10.94 12 3.22 4.28Z"
      />
    </svg>
  );
}
